var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShowLessArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 10,
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3710_4778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.5L0 8.13251L1.34375 9.5L7.5 3.20318L13.6562 9.4682L15 8.10071L7.5 0.5Z",
    fill: "#007DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3710_4778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 9,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 9.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowLessArrow);
export default __webpack_public_path__ + "static/media/showLessArrow.2971048730a1216c48526d30b5e23a11.svg";
export { ForwardRef as ReactComponent };